import React from "react";
import { Zap, Power, Factory, Building, Home, Settings } from "lucide-react";
import { services } from "../mock";

const Services = () => {
  const iconMap = {
    Zap: Zap,
    Power: Power,
    Factory: Factory,
    Building: Building,
    Home: Home,
    Settings: Settings,
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-32 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              Our Services
            </h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              Comprehensive electrical, technical, and management services across all sectors
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="space-y-20">
            {services.map((service, index) => {
              const Icon = iconMap[service.icon];
              const isEven = index % 2 === 0;

              return (
                <div
                  key={service.id}
                  className={`grid lg:grid-cols-2 gap-12 items-center ${
                    !isEven ? "lg:flex-row-reverse" : ""
                  }`}
                >
                  <div className={`space-y-6 ${!isEven ? "lg:order-2" : ""}`}>
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-xl">
                      <Icon size={32} className="text-blue-600" />
                    </div>
                    <h2 className="text-4xl font-bold text-gray-900">
                      {service.title}
                    </h2>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {service.description}
                    </p>
                    <button className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors">
                      Learn More
                    </button>
                  </div>
                  <div className={`relative ${!isEven ? "lg:order-1" : ""}`}>
                    <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-[400px] object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent"></div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Comprehensive Service Offerings
            </h2>
            <p className="text-xl text-gray-600">
              From everyday repairs to complex project delivery
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              "Electrical Installations",
              "System Upgrades",
              "Planned Maintenance",
              "Emergency Repairs",
              "Full Electrical Fit-outs",
              "Engineering Solutions",
              "Project Delivery",
              "Asset Integrity Services",
              "Technical Consulting",
            ].map((offering, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow border border-gray-100"
              >
                <div className="flex items-center space-x-4">
                  <div className="w-3 h-3 bg-blue-600 rounded-full flex-shrink-0"></div>
                  <span className="text-lg font-semibold text-gray-900">{offering}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Compliance Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl p-12 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Queensland Compliance Guaranteed
            </h2>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              All our work meets Queensland's regulatory, safety, and performance requirements. Our technicians combine trade capability with strong technical expertise.
            </p>
            <button className="px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-blue-50 transition-colors shadow-lg">
              Request Consultation
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
